module.exports = __webpack_public_path__ + "static/media/DataIntegration.30602366.svg";